"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MedicalCodeAccordionHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var conditional_1 = require("../../conditional/conditional");
var EditorIssueLevel = ui_common_1.commonEnums.EditorIssueLevel;
/**
 * React component that displays a Header
 * @param medicalCode
 * @param techTransaction
 * @param errors
 * @param invoice
 * @param codeEdits
 * @returns
 */
var MedicalCodeAccordionHeader = function (medicalCode, techTransaction, errors, invoice, codeEdits) {
    var _a;
    var _b, _c, _d, _e;
    if (ui_common_1.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "medical-code-accordion-header icd-code transaction-shared-code-list" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "move-column" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-gripper prevent-click" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeGripperSVG20", svgIconSize: "20", svgIconClass: "gripper" }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "codes-column" }, { children: medicalCode.codes.map(function (medicalCode, idx) {
                        var active = medicalCode.active;
                        var classes = (0, classnames_1["default"])([
                            'chip',
                            {
                                'shared-code-on': active,
                                'shared-code-off': !active
                            }
                        ]);
                        // change icon here... turned off for now.
                        var iconName = active ? 'BiomeCheckSVG20' : 'BiomeMinusSVG20';
                        return ((0, jsx_runtime_1.jsx)("span", __assign({ className: "icd-code unclickable prevent-click", "data-dd-action-name": active === true ? '~Toggle code off' : '~Toggle code on' }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-chip" }, { children: (0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes }, { children: [active && ((0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: iconName, svgIconSize: "20", svgIconClass: "shared-icon" })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-text" }, { children: medicalCode.code }))] })) }) })) }), medicalCode.code));
                    }) }))] })));
    }
    else if (ui_common_1.cmxTypeguards.isChargeSessionCode(medicalCode)) {
        //@ts-ignore
        var shared = (_b = medicalCode.shared) !== null && _b !== void 0 ? _b : false;
        var sharedInvoice = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES;
        var uneditableSharedCode = shared && !sharedInvoice;
        var allEdits = (_c = codeEdits[medicalCode.code]) !== null && _c !== void 0 ? _c : [];
        var vwErrors = allEdits.some(function (edit) { return edit.level === EditorIssueLevel.ERROR; });
        var vwWarnings = allEdits.some(function (edit) { return edit.level === EditorIssueLevel.WARNING; });
        var styleClasses = [
            "medical-code-accordion-header",
            (_a = {
                    'code-errors': errors.some(function (error) {
                        return (error.message_key === 'procedure_code.units.invalid' &&
                            medicalCode.codeType === 'procedure') ||
                            error.message_key !== 'procedure_code.units.invalid';
                    }),
                    unitable: medicalCode.unitable,
                    editable: medicalCode.editable,
                    'uneditable-shared-code': uneditableSharedCode
                },
                _a['transaction-shared-code'] = shared,
                _a),
            "".concat(medicalCode.provenance.toLowerCase(), "-code")
        ];
        var evidence = (_d = medicalCode.evidence) !== null && _d !== void 0 ? _d : [];
        var hasEvidence = (_e = evidence.length > 0) !== null && _e !== void 0 ? _e : false;
        var isProcedureCode = medicalCode.codeType === 'procedure';
        var description = medicalCode.description || 'Retrieving description...';
        var codeUnitsStyle = [
            'code-units-input',
            {
                'procedure-code-units-invalid': errors.some(function (error) { return error.message_key === 'procedure_code.units.invalid'; })
            }
        ];
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-code": "".concat(medicalCode.code), "data-code-type": "".concat(medicalCode.codeType), className: (0, classnames_1["default"])(styleClasses) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "units-column" }, { children: (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: !isProcedureCode }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-gripper prevent-click" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeGripperSVG20", svgIconSize: "20", svgIconClass: "gripper" }) })) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "codes-column" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-chip" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "chip" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-text" }, { children: medicalCode.code })) })) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ title: description, className: "qa-description-column description-column" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "ellipsify" }, { children: description })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "code-actions-column" }, { children: hasEvidence && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-evidence code-indicator-cell" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "indicator" }, { children: "CMX" })) }))) }))] }), "".concat(medicalCode.code, "-").concat(medicalCode.codeType)));
    }
};
exports.MedicalCodeAccordionHeader = MedicalCodeAccordionHeader;
//# sourceMappingURL=medical-code-accordion-header.js.map